export default {"src":"/_next/static/media/step_background_1.ae28b11d.svg","height":134,"width":134,"blurWidth":0,"blurHeight":0};